import { render, staticRenderFns } from "./DetailOrderSummary.vue?vue&type=template&id=cb3e5fce"
import script from "./DetailOrderSummary.vue?vue&type=script&lang=js"
export * from "./DetailOrderSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb3e5fce')) {
      api.createRecord('cb3e5fce', component.options)
    } else {
      api.reload('cb3e5fce', component.options)
    }
    module.hot.accept("./DetailOrderSummary.vue?vue&type=template&id=cb3e5fce", function () {
      api.rerender('cb3e5fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PanelGroup/DetailOrderSummary.vue"
export default component.exports